"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useJssStyles;

var _react = require("react");

function useJssStyles() {
  (0, _react.useEffect)(function () {
    // Remove the server-side injected CSS.
    var jssStyles = document.querySelector('#jss-server-side');

    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, []);
}
//# sourceMappingURL=useJssStyles.js.map